import React from "react";
import translate from "../../../translate";

export default function Error({ translationKey }) {
    return <div className={'bg-error pl-2 pr-2 p-1 mb-1 mt-1'}>{translate(translationKey)}</div>
}
